import { render, staticRenderFns } from "./ListGithubUserView.vue?vue&type=template&id=4b6617f6"
import script from "./ListGithubUserView.vue?vue&type=script&lang=ts"
export * from "./ListGithubUserView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports